<template>
  <div class="select-popup">
    <div
      class="popup-box"
      :style="{ minWidth: size || '240px' }">
      <slot></slot>
    </div>
    <div class="popup-overlay" @click="closePopup"></div>

    <div class="popup-loading" v-show="showLoading">
      <Loading></Loading>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/main';
import Loading from '@/components/Templates/Loading.vue';

export default {
  name: 'SelectPopup',
  components: {
    Loading
  },
  props: [
    'size',
    'closePopup',
    'showLoading'
  ]
}
</script>

<style lang="scss">
.select-popup {
  position: relative;
  .popup-box {
    position: relative;
    background-color: #fff;
    padding: 20px 20px;
    border-radius: 2px;
    // box-shadow: 1px 1px 6px 1px #888;
    z-index: 8999;
    box-shadow: 0 0 1px rgba(76,86,103,.25), 0 2px 18px rgba(31,37,50,.32)
  }
  .popup-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 8998;
  }
}

.popup-loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.9);
  z-index: 9999;

  .vlt-loading {
    position: relative;
    top: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slots/SelectPopup.vue